/** File for interacting with DateTime Objects */
import moment from 'moment';

/**
 * Sets the 'time' (Hour, and minute) values of a datetime object, maintaining 'date' (Day, Month, and above)
 * This is currently only accurate down to the minute.
 * @param dateTime Moment object with the intial datetime to modify
 * @param time Moment object with the time to set. (Date values are ignored)
 * @returns Moment object with time from 'time' and date from 'dateTime'
 */
export const setTimeofDateTime = (dateTime: moment.Moment, time: moment.Moment) : moment.Moment =>
{
    let actEventStartDateTime = new Date(dateTime.toDate());
    actEventStartDateTime.setHours(time.hours());
    actEventStartDateTime.setMinutes(time.minutes());
    return moment(actEventStartDateTime);
}